import { VendingRecycleSpotFillRateLineChart } from '@frontend/chart/components';
import { FormattedMessage } from 'react-intl';

import { InsightCardWidth } from '../insight-card-width';
import { InsightCard } from '../insight-card/insight-card.component';
import { useInsightChartMinHeight } from '../insight-detail-mode.context';
import { InsightId } from '../insight-registry/insight-ids';
import { useLast30DaysVendingRecycleSpotFillRateLineChart } from './use-last-30-days-vending-recycle-spot-fill-rate-line-chart';

export interface Last30DaysVendingRecycleSpotFillRateLineChartProps {
    accountId: string;
    width?: InsightCardWidth;
}

export const Last30DaysVendingRecycleSpotFillRateLineChart = ({ accountId, width }: Last30DaysVendingRecycleSpotFillRateLineChartProps) => {
    const chartMinHeight = useInsightChartMinHeight(220);
    const { data, isLoading, hasData } = useLast30DaysVendingRecycleSpotFillRateLineChart(accountId);

    return (
        <InsightCard
            insightId={InsightId.VENDING_RECYCLE_SLOTS_FILL_RATE}
            chartKey={VendingRecycleSpotFillRateLineChart.definition.key}
            width={width}
            title={
                <FormattedMessage
                    id='platform.analytics.insights.vending-recycle-slots-fill-rate-metric-chart.title'
                    description='Title for the vending recycle SLOT occupancy percentage metric on analytics insights'
                    defaultMessage='Recycle slots fill rate'
                />
            }
            subtitle={
                <FormattedMessage
                    id='platform.analytics.insights.last-30-days-vending-recycle-spot-fill-rate-line-chart.subtitle'
                    description='Subtitle on the vending recycle fill rate line chart indicating the chart covers the last 30 days'
                    defaultMessage='last 30 days'
                />
            }
            isLoading={isLoading}>
            {hasData && data ? (
                <div
                    className='mt-auto h-full min-h-0 w-full flex-1'
                    style={{ minHeight: chartMinHeight }}>
                    <VendingRecycleSpotFillRateLineChart
                        data={data}
                        minHeight={chartMinHeight}
                        showLabels='minimal'
                        tooltipShared
                    />
                </div>
            ) : null}
        </InsightCard>
    );
};
